<template>
  <div>
    <v-card class="pa-2 ma-0">
      <v-expansion-panel flat class="pa-0 ma-0 has-border-bottom" style="padding: 0px !important">
        <v-expansion-panel-content>
          <template v-slot:header class="ma-0 pa-0">
            <v-card flat class="pa-0">
              <v-layout row wrap>
                <v-flex xs4>
                  <v-btn flat class="pl-0 mr-2" @click="caricaDati" @click.native.stop fab>
                    <v-icon left class="mr-2 ml-0">refresh</v-icon>
                  </v-btn>
                </v-flex>

                <v-flex xs8>
                  <v-menu ref="menu" v-model="menuData" :close-on-content-click="true" :nudge-right="40" lazy
                    transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="dataConsegnaFormat" label="Data" persistent-hint prepend-icon="event"
                        v-on="on" style="max-width: 150px" @click.native.stop readonly></v-text-field>
                    </template>
                    <v-date-picker v-model="dataConsegna" no-title @input="menu1 = false" locale="it-it"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-card>
          </template>

          <v-card flat class="pa-2">
            Localizzazione:{{ servizio }} Stato:{{
              movimento ? "In movimento" : "Stop"
            }}
            <br />
            {{ "Lat. " + coord.lat + " Long. " + coord.lon }}
            <br />
            {{ "Data rilevamento " + coord.dataRilevamento }}
            <br />
            {{ "Data ultimo invio " + coord.dataUltimoInvio }}
            <br />
            <v-btn @click="invioManuale" flat outline small>Invia</v-btn>
            <v-btn @click="richiediCoordinate" flat outline small>Coordinate</v-btn>
            <v-btn @click="resetConsegne" flat outline small>Pulisci invii</v-btn>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Attesa -->
      <v-progress-circular indeterminate color="primary" v-if="attesa"
        style="display: flex; margin: 0 auto"></v-progress-circular>

      <v-card flat tile v-for="(item, i) in getDati" :key="i" class="py-2 px-2 has-border-bottom"
        @click="visualizzaInfo(item)" style="cursor: pointer">
        <v-card-text class="pa-0">
          <v-layout row wrap>
            <v-flex xs9>
              <span class="ragione-sociale">{{ item.ragioneSociale }}</span>
              <span>
                {{ item.localita }}
                <br />
                {{ item.indirizzo }}
              </span>
            </v-flex>
            <v-flex xs3 class="text-right-aligned">
              <span class="ora-prevista" :class="Date.parse(item.tempoPrevisto) < new Date()
                  ? 'ora-ritardo'
                  : ''
                ">{{ item.tempoPrevisto.substr(11, 5) }}</span>
              <span>{{ getDataScarico(item) }}</span>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <!-- Dialog dettaglio -->
      <dialogDettaglio :dialog="dialog" :dati="datiSel.consegne" :datiDettaglio="datiSel.dettaglio" @chiudi="chiudiDialog"
        @scaricato="scaricaConsegna"></dialogDettaglio>
    </v-card>
  </div>
</template>

<script>
import { get_consegne, invia_coordinate, scarica_consegna } from "@/api/api.js";
import dialogDettaglio from "@/components/dialog/DialogConsegna.vue";
import storage from "@/services/storage.js";

export default {
  components: {
    dialogDettaglio,
  },

  data() {
    return {
      dati: [],
      dettaglio: [],

      dataConsegna: new Date().toISOString().substr(0, 10),
      menuData: false,

      dialog: false,
      tabs: null,
      datiSel: { consegne: {}, dettaglio: {} },
      attesa: false,

      coord: { lat: 0, lon: 0, dataRilevamento: "", dataUltimoInvio: "" },
      movimento: false,
      servizio: "",
      dataInvioPrec: [],
    };
  },

  methods: {
    async caricaDati() {
      this.attesa = true;

      // Reset
      this.dati = [];
      this.dettaglio = [];
      this.dataInvioPrec = [];
      this.resetConsegne();

      // Param
      const [year, month, day] = this.dataConsegna.split("-");
      let par =
        year +
        "-" +
        month +
        "-" +
        day +
        "/" +
        this.$store.getters["user/getUser"] +
        "/completo" +
        this.getCache();

      try {
        let res = await get_consegne(par);

        this.dati = res.data.consegne;
        this.dettaglio = res.data.dettaglioConsegna;
      } catch (error) {
        this.$toast.warning(this.$functions.getErrorMsg(error));
      }

      this.attesa = false;
    },

    visualizzaInfo(item) {
      this.datiSel.consegne = item;
      this.datiSel.dettaglio = this.dettaglio.find(
        (f) => f.ordine_Passaggio == item.prog
      );

      this.dialog = true;
    },

    scaricaConsegna(datiDettaglio, progConsegna) {
      // Imposto la consegna come scaricata
      this.dati.find((f) => f.prog == progConsegna).scaricato = true;

      // Controllo presenza dettaglio
      // NOTA: capita che magari bloccano il giro e tolgono dopo delle consegne, rimane solo la testata
      if (Object.keys(datiDettaglio).length > 1) {
        // NOTA: mantengo nello storage le consegne (se non c'è rete, verranno inviate successivamente)
        storage.setConsegne(datiDettaglio);
        // Invio le consegne
        this.inviaConsegne();
      }

      this.dialog = false;
    },

    getUtente() {
      return this.$store.getters["user/getUser"];
    },

    getDataScarico(item) {
      return item.dataScarico ? item.dataScarico.substr(11, 5) : "";
    },

    chiudiDialog() {
      this.dialog = false;
    },

    getCache() {
      return "?" + new Date().getTime();
    },

    async inviaConsegne() {
      let data = storage.getConsegne();
      if (data.length == 0) return;

      try {
        await scarica_consegna(data);

        // L'invio è andato a buon fine, pulisco lo storage
        storage.delConsegne();
      } catch (error) {
        console.log(error);
        this.$toast.warning(this.$functions.getErrorMsg(error));
      }
    },

    resetConsegne() {
      // Reset consegne memorizzate
      storage.delConsegne();
    },

    invioManuale() {
      try {
        let _this = this;

        // Ricavo la posizione corrente
        navigator.geolocation.getCurrentPosition(function (position) {
          _this.setGpsLocation(position, true);

          _this.inviaCoordinate();
        });

        // Consegne
        this.inviaConsegne();
      } catch (error) {
        console.log(error);
        this.$toast.warning(this.$functions.getErrorMsg(error));
      }
    },

    async inviaCoordinate() {
      let data = storage.getGps();
      if (data.length == 0) return;

      try {
        await invia_coordinate(data);

        // L'invio è andato a buon fine, pulisco lo storage
        storage.delGps();

        // Memorizzo la data di invio
        this.coord.dataUltimoInvio = this.$functions.formatDateTime(new Date());
      } catch (error) {
        console.log(error);
      }
    },

    async richiediCoordinate() {
      // You could request a new location if you wish.
      window.BackgroundGeolocation.getCurrentPosition({
        samples: 1,
        persist: true,
      }).then((location) => {
        console.log("[getCurrentPosition] ", location);

        this.coord.lat = location.coords.latitude;
        this.coord.lon = location.coords.longitude;
      });
    },

    setGpsLocation(position, force) {
      let lat = position.coords.latitude;
      let lon = position.coords.longitude;

      this.coord.lat = lat;
      this.coord.lon = lon;
      this.coord.dataRilevamento = this.$functions.formatDateTime(new Date());

      // Controllo forzatura invio
      if (force == false) {
        // Controllo sede Barge
        if (lat >= 44.72 && lat <= 44.74 && lon >= 7.34 && lon <= 7.35) return;

        // Controllo movimento
        if (this.movimento == false) return;
      }

      let par = {
        data: this.$functions.getDateIso(),
        latitudine: lat,
        longitudine: lon,
        terminale: this.getUtente(),
        operazione: "VIAGGIO",
      };

      // Memorizzo nello storage la posizione
      storage.setGps(par);
    },

    getDateNoSec() {
      let tzoffset = new Date().getTimezoneOffset() * 60000;
      let d = new Date(Date.now() - tzoffset);
      d.setSeconds(0, 0); // Imposto i secondi a zero (equivale a toglierli)
      let localISODate = d.toISOString().slice(0, -1);
      localISODate = localISODate.split(".")[0]; // Tolgo i millisecondi
      return localISODate;
    },
  },

  mounted() {
    this.caricaDati();
  },

  destroyed() {
    // Controllo web
    if (this.$functions.CordovaApp() == false) return;

    // Interrompo la geolocalizzazione
    window.BackgroundGeolocation.stop();
  },

  computed: {
    getTipo() {
      return this.$store.getters["app/getTipo"] == "consegnato";
    },

    getDati() {
      return this.dati.filter((f) => f.scaricato == this.getTipo);
    },

    dataConsegnaFormat: {
      get: function () {
        if (this.dataConsegna.length == 0) return "";

        const [year, month, day] = this.dataConsegna.split("-");
        return `${day}/${month}/${year}`;
      },
      set: function (v) { },
    },
  },
};
</script>